// FT-183: какие разделы и поля интерфейса скрыты для типа техники компании.
//
// Зачем: вело-прокаты (и прокаты самокатов — тот же тип `bicycles`) видели
// автомобильное — штрафы, пробег, топливо, страховки, агрегатор, интеграции
// карточки ТС. Решение «что скрыть» живёт ТОЛЬКО здесь: компоненты, роутер и
// страницы разделов спрашивают этот модуль, а не сравнивают тип сами.
// Добавить тип — одна строка в HIDDEN_FEATURES.
//
// Таблица закрыта по умолчанию: тип не в таблице, пустое или неизвестное значение
// (новый enum на бэкенде) — ничего не скрыто, как у авто. Скрывается только
// интерфейс: API, данные и записанные суммы не меняются.

export const FEATURES = Object.freeze([
  "fines",
  "mileage",
  "fuel",
  "insurance",
  "aggregators",
  "car_integrations",
]);

// Собственные ключи без прототипа: тип "constructor" или "__proto__" не должен
// найти в таблице служебное свойство Object.
const HIDDEN_FEATURES = Object.assign(Object.create(null), {
  bicycles: FEATURES,
});

// Разделы, целиком закрытые вместе с фичей: пункты меню и прямые ссылки.
// Путь раздела матчится сам и с подпутями (`/fines/abc`), но не по началу слова
// (`/finesse` — не раздел штрафов).
const FEATURE_ROUTES = [
  ["/fines", "fines"],
  ["/new_fine", "fines"],
  ["/service_insurance", "insurance"],
  ["/agregator/settings", "aggregators"],
];

// Прочие сущности интерфейса, принадлежащие фиче. Ключи — значения, которые
// приходят из данных и шаблонов: вариант доплаты при возврате (строка-значение
// add_services), слот arrival_payments, тип виджета дашборда, maintenance_type.
export const ADD_SERVICE_FEATURES = Object.freeze({
  "Штрафы": "fines",
  "Превышение пробега": "mileage",
  "Топливо": "fuel",
  "Страховка": "insurance",
});
export const PAYMENT_SLOT_FEATURES = Object.freeze({
  fine: "fines",
  mileage: "mileage",
  gas: "fuel",
  insurance: "insurance",
});
export const WIDGET_FEATURES = Object.freeze({ fines_sale_end: "fines" });
// maintenance_type 4 — страхование ТС (5 — налоги, остаются).
const MAINTENANCE_TYPE_FEATURES = Object.freeze({ 4: "insurance" });

export function rentalObjectHas(rentalObject, feature) {
  const hidden = HIDDEN_FEATURES[rentalObject];
  return !(hidden && hidden.includes(feature));
}

// Видна ли сущность, отнесённая к фиче словарём выше (ключ не в словаре — видна).
export function keyVisible(rentalObject, features, key) {
  const feature = features[key];
  return !feature || rentalObjectHas(rentalObject, feature);
}

export function routeFeature(path) {
  if (!path) return null;
  const found = FEATURE_ROUTES.find(([route]) => path === route || path.startsWith(`${route}/`));
  return found ? found[1] : null;
}

export function routeVisible(rentalObject, path) {
  const feature = routeFeature(path);
  return !feature || rentalObjectHas(rentalObject, feature);
}

export function maintenanceVisible(rentalObject, maintenance) {
  return keyVisible(rentalObject, MAINTENANCE_TYPE_FEATURES, maintenance && maintenance.maintenance_type);
}

// Тип техники из обёртки стора `getCompany` ({ company }). Без фолбэка: пусто —
// значит компания ещё не известна (гейты fail-open), а таблица на пустом типе
// ничего не скрывает.
export function companyRentalObject(companyWrapper) {
  return (companyWrapper && companyWrapper.company && companyWrapper.company.rental_object) || null;
}
